import styles from "./TextInput.module.css";

const TextInput = ({
  value,
  type="text",
  placeholder,
  className,
  containerClassName,
  placeholderClassName,
  ...props
}) => {
  return (
    <div
      className={`relative ${containerClassName ?? ""} ${
        styles.floatinglabelinput
      }`}
    >
      <input
        type={type}
        className={`text-sm bg-[#2C2D36] placeholder-transparent border-[#444444] border rounded-full px-4 pb-2 py-6 focus:outline-none focus:ring-1 focus:ring-[#444444] ${
          className ?? ""
        }`}
        value={value}
        {...props}
      />
      <label
        className={`text-[#5d5d64] ${placeholderClassName ?? ""} ${
          value ? styles.filledlabel : ""
        }`}
      >
        {placeholder}
      </label>
    </div>
  );
};

export default TextInput;
